import React from "react";

export function H2({ className = "", ...props }) {
  return (
    <h2 className={`text-xl font-bold text-blue-900 ${className}`} {...props} />
  );
}
